import update from 'react-addons-update';
import { createAction, handleActions } from 'redux-actions';

import { IBrandSafetyRule } from '~/src/dash/api/brand-safety-rules';
import {
  IAdunit,
  IChannelGroup,
  IDemandSourceNameMap,
  IPublisher,
  ISite,
} from '~/src/dash/api/console-api';
import { IMonitor } from '~/src/dash/api/monitors/monitors_models';
import { ISearchFilter } from '~/src/dash/utils/filter-search';

export interface ISessionState {
  publisher: IPublisher;
  // deprecated please don't use anymore!!!
  sites: ISite[];
  // deprecated please don't use anymore!!!
  site?: ISite;
  monitors: IMonitor[]; // must be all (non-deleted monitors)
  adunits: IAdunit[];
  adunit: IAdunit;
  cloneBidderID?: string;
  channelGroups: IChannelGroup[];
  brandSafetyRules: IBrandSafetyRule[];
  brandSafetyReferrer: BrandSafetyReferrer;
  searches: ISearchFilter;
  demandSourceNameMap: IDemandSourceNameMap;
}

export type BrandSafetyReferrer = string;
export const BrandSafetyReferrerBrandSafetyTracker: BrandSafetyReferrer = 'brandsafetytracker';

const initialState: ISessionState = {
  publisher: undefined,
  sites: [],
  site: undefined,
  selectedChannelGroups: [],
  selectedSites: [],
  adunits: [],
  adunit: undefined,
  bidderGroups: [],
  channelGroups: [],
  searches: {} as ISearchFilter,
  DemandSourceUIToDBNames: [],
} as any;

const ACT_SESSION_SET = 'ACT_SESSION_SET';
const ACT_SESSION_RESET = 'ACT_SESSION_RESET';

export const SESSION_ACTIONS_SET = createAction(ACT_SESSION_SET);

export const sessionReducers = handleActions(
  {
    [ACT_SESSION_SET]: (state: ISessionState, action: any) => {
      return update(state, {
        $merge: action.payload,
      });
    },
    [ACT_SESSION_RESET]: (state: ISessionState, action: any) => {
      return update(state, {
        $set: Object.assign({}, initialState, action.payload),
      });
    },
  },
  initialState,
);
